export const mapping_Name_To_Title = {
  request_manage: "需求管理",
  request_version_manage: "版本更新",
  request_download_manage: "购买记录",
  request_download_version_manage: "需求下载",
  request_module_download_manage: "需求项下载",
  request_ui_controller: "UI控件管理",
  workflow_controller: "工作流组件管理",
  standard_valuation_management: "标准估价管理",
  demand_manage: "需求项管理",
  demand_manage_version: "版本管理",
  request_check_rule: "完备性检查规则",
  request_standard_distribute: "需求规范下发",
  non_function_request: "非功能需求",
  delivery_require: "交付要求",
  icon_image: "图标管理",
  data_entity: "数据实体",
  request_in_lib: "需求",
  adap_user_manual: "Adap帮助",
  prompt_template: "提示词模板管理",
};
